module.exports = __webpack_public_path__ + "img/edit_calendar_outlined.316165ab.svg";